module.exports = __webpack_public_path__ + "static/img/1-1.dedf392.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/1-1.png
// module id = 1306
// module chunks = 0